// Registro local de lo último que el usuario abrió (fichas GES, fármacos…),
// para el "sigue donde quedaste" del inicio. Solo metadata mínima, en
// localStorage; degradación silenciosa si no está disponible.

const KEY = "mipae_recientes";
const MAX = 6;

export function getRecientes() {
  try {
    const a = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(a) ? a : [];
  } catch {
    return [];
  }
}

/**
 * Agrega (o sube al tope) un elemento reciente y devuelve la lista resultante.
 * @param {{ tipo: string, slug: string, label: string, modulo?: string }} item
 * @returns {Array}
 */
export function addReciente(item) {
  if (!item || !item.slug || !item.tipo) return getRecientes();
  try {
    const prev = getRecientes().filter((r) => !(r.tipo === item.tipo && r.slug === item.slug));
    const next = [{ tipo: item.tipo, slug: item.slug, label: item.label || item.slug, modulo: item.modulo || item.tipo, ts: Date.now() }, ...prev].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
    return next;
  } catch {
    return getRecientes();
  }
}

// ── Conjunto acumulado de fichas GES exploradas (para el progreso de estudio) ──
const VISTAS_GES_KEY = "mipae_ges_vistas";

export function getVistasGes() {
  try {
    const a = JSON.parse(localStorage.getItem(VISTAS_GES_KEY) || "[]");
    return Array.isArray(a) ? a : [];
  } catch {
    return [];
  }
}

export function addVistaGes(slug) {
  if (!slug) return getVistasGes();
  try {
    const s = new Set(getVistasGes());
    s.add(slug);
    const a = [...s];
    localStorage.setItem(VISTAS_GES_KEY, JSON.stringify(a));
    return a;
  } catch {
    return getVistasGes();
  }
}
